import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_FEATURE_CONTROL, UPDATE_FEATURE_CONTROLS } from './actionTypes';
import { FEATURE_KEYS } from './constants';
const DEFAULT_STATE = {
    [FEATURE_KEYS.LIVESTREAMING]: true,
    [FEATURE_KEYS.SHARED_VIDEO]: true,
    [FEATURE_KEYS.SHARE_AUDIO]: true,
    [FEATURE_KEYS.NOISE_SUPPRESSION]: true,
    [FEATURE_KEYS.WHITEBOARD]: true
};
ReducerRegistry.register('features/feature-controls', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_FEATURE_CONTROL:
            return {
                ...state,
                [action.feature]: action.enabled
            };
        case UPDATE_FEATURE_CONTROLS:
            return {
                ...state,
                ...action.featureControls
            };
    }
    return state;
});
